/**
 * @flow
 * @relayHash d96e910dd111a3e95734dc7549ed50fb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InvoiceStatus = "DRAFT" | "OVERDUE" | "PAID" | "PARTIALLY_PAID" | "SENT" | "VOID";
export type UpdateInvoiceInput = {|
  id: string,
  orderId?: ?string,
  customerId?: ?string,
  status?: ?InvoiceStatus,
  currency?: ?string,
  discountPercent?: ?number,
  taxRate?: ?number,
  billingAddressLine1?: ?string,
  billingAddressLine2?: ?string,
  billingAddressCity?: ?string,
  billingAddressState?: ?string,
  billingAddressZip?: ?string,
  issueDate?: ?any,
  dueDate?: ?any,
  paidDate?: ?any,
  notes?: ?string,
  terms?: ?string,
  partialPercent?: ?number,
  milestoneLabel?: ?string,
|};
export type UpdateInvoiceMutationVariables = {|
  input: UpdateInvoiceInput
|};
export type UpdateInvoiceMutationResponse = {|
  +updateInvoice: {|
    +invoiceEdge: {|
      +node: {|
        +id: string,
        +invoiceNumber: string,
        +status: InvoiceStatus,
        +currency: string,
        +subtotal: number,
        +discountPercent: number,
        +discountAmount: number,
        +taxRate: number,
        +taxAmount: number,
        +totalAmount: number,
        +amountPaid: number,
        +amountDue: number,
        +partialPercent: number,
        +milestoneLabel: ?string,
        +issueDate: ?any,
        +dueDate: ?any,
        +paidDate: ?any,
        +notes: ?string,
        +terms: ?string,
        +order: ?{|
          +id: string,
          +orderNumber: string,
        |},
        +customer: {|
          +id: string,
          +name: string,
        |},
        +updatedAt: any,
        +createdAt: any,
      |}
    |}
  |}
|};
export type UpdateInvoiceMutation = {|
  variables: UpdateInvoiceMutationVariables,
  response: UpdateInvoiceMutationResponse,
|};
*/


/*
mutation UpdateInvoiceMutation(
  $input: UpdateInvoiceInput!
) {
  updateInvoice(input: $input) {
    invoiceEdge {
      node {
        id
        invoiceNumber
        status
        currency
        subtotal
        discountPercent
        discountAmount
        taxRate
        taxAmount
        totalAmount
        amountPaid
        amountDue
        partialPercent
        milestoneLabel
        issueDate
        dueDate
        paidDate
        notes
        terms
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        updatedAt
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateInvoiceInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateInvoice",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateInvoicePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "invoiceEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "InvoiceEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "invoiceNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "currency",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subtotal",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountPercent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "discountAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "taxRate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "taxAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amountPaid",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "amountDue",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "partialPercent",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "milestoneLabel",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "issueDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "dueDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "paidDate",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "terms",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "order",
                "storageKey": null,
                "args": null,
                "concreteType": "Order",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "orderNumber",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "name",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "updatedAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateInvoiceMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateInvoiceMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateInvoiceMutation",
    "id": null,
    "text": "mutation UpdateInvoiceMutation(\n  $input: UpdateInvoiceInput!\n) {\n  updateInvoice(input: $input) {\n    invoiceEdge {\n      node {\n        id\n        invoiceNumber\n        status\n        currency\n        subtotal\n        discountPercent\n        discountAmount\n        taxRate\n        taxAmount\n        totalAmount\n        amountPaid\n        amountDue\n        partialPercent\n        milestoneLabel\n        issueDate\n        dueDate\n        paidDate\n        notes\n        terms\n        order {\n          id\n          orderNumber\n        }\n        customer {\n          id\n          name\n        }\n        updatedAt\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '702fca885f0a632e28fb890b0c2bb141';
module.exports = node;
